import { render, staticRenderFns } from "./scoreInfo.vue?vue&type=template&id=69103a4a&scoped=true&"
import script from "./scoreInfo.vue?vue&type=script&lang=js&"
export * from "./scoreInfo.vue?vue&type=script&lang=js&"
import style0 from "./scoreInfo.vue?vue&type=style&index=0&id=69103a4a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69103a4a",
  null
  
)

export default component.exports